<script setup lang="ts">
import HelloWorld from './components/HelloWorld.vue';
import TokenInput from '@/components/TokenInput.vue';
import { useTokenStore } from '@/stores/token.js';
import Counts from '@/components/Counts.vue';
import Jobs from '@/components/Jobs.vue';
import { useJobStore } from '@/stores/jobs.js';
import { storeToRefs } from 'pinia';

const tokenStore = useTokenStore();
const { showCurrentQueue } = storeToRefs(useJobStore());
</script>

<template>
  <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto font-sans">
    <!-- Title -->
    <div class="max-w-2xl mx-auto text-center mb-10 lg:mb-14">
      <h2 class="text-2xl font-bold md:text-4xl md:leading-tight">Redis Queue Dashboard</h2>
      <p class="mt-1 text-gray-600">View current counts and jobs in the Redis queue.</p>
      <div
        class="flex items-center justify-center cursor-pointer"
        @click="tokenStore.editToken = !tokenStore.editToken"
      >
        <div class="mr-1">Change Token</div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
          />
        </svg>
      </div>
    </div>
    <TokenInput />
    <Jobs v-if="showCurrentQueue" class="mt-8" />
    <Counts v-else class="mt-8" />
  </div>
</template>
